import {Box, Link, Stack, Typography} from "@mui/material";
import React from "react";
import {Link as RouterLink} from "react-router-dom";

import LightTooltip from "../../../utils/LightTooltip";

function ContentItemTitle(props: {
	primary: React.ReactNode;
	secondary: React.ReactNode;
	icon?: React.ReactNode;
	link?: string;
}) {
	const title = (
		<Stack sx={{width: 1}}>
			<Typography variant="inherit" sx={{display: "flex"}}>
				<LightTooltip
					title={<Typography variant="body2">{props.primary}</Typography>}
					placement="top-start"
					enterDelay={500}
					enterNextDelay={500}
				>
					<span
						style={{
							whiteSpace: "nowrap",
							overflow: "hidden",
							textOverflow: "ellipsis",
						}}
					>
						{props.link ? (
							<Link component={RouterLink} to={props.link}>
								{props.primary}
							</Link>
						) : (
							props.primary
						)}
					</span>
				</LightTooltip>
			</Typography>
			<Typography variant="inherit" color="textSecondary">
				{props.secondary}
			</Typography>
		</Stack>
	);

	if (!props.icon) {
		return title;
	}

	return (
		<Stack direction="row" spacing={1.5}>
			<Box
				sx={{
					color: (theme) => theme.palette.text.secondary,
					display: "flex",
					alignItems: "center",
				}}
			>
				{props.icon}
			</Box>
			{title}
		</Stack>
	);
}

export default ContentItemTitle;
